import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [perms, setPerms] = useState(null); // { module: { view, create, edit, delete, bulk } }

  const loadPerms = () => {
    api.get('/settings/permissions/me')
      .then(r => setPerms(r.data.permissions))
      .catch(() => setPerms(null));
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me').then(r => { setUser(r.data); loadPerms(); }).catch(() => { localStorage.removeItem('token'); }).finally(() => setLoading(false));
    } else { setLoading(false); }
  }, []);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', r.data.token);
    setUser(r.data.user);
    loadPerms();
    return r.data;
  };

  const logout = () => { localStorage.removeItem('token'); setUser(null); setPerms(null); };

  const refreshUser = async () => {
    try {
      const r = await api.get('/auth/me');
      setUser(r.data);
      loadPerms();
      return r.data;
    } catch (e) { return null; }
  };

  // Permission check for UI gating. Permissive while perms are loading —
  // the backend permGuard is the actual enforcement.
  const can = useCallback((module, action = 'view') => {
    if (!perms) return true;
    return !!perms[module]?.[action];
  }, [perms]);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser, setUser, can, perms, reloadPerms: loadPerms }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
